﻿import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ShowHide } from 'components/layout';

export function ArrayToEllipsesString(
    {
        length = 3,
        joinCharacter = ', ',
        multiline = false,
        children
    }
) {
    if (!children) {
        return null;
    }

    if (multiline) {
        return renderMultiline(children, length);
    }

    return ((children.length > length) ? <Fragment>{arrToEllipsesLength(children, length, joinCharacter)}&hellip;</Fragment> : defaultJoin(children, joinCharacter));        
}

// One item per line, with the ellipsis on its own final line when items were dropped. The
// joinCharacter does not apply here — the line break is the separator.
function renderMultiline(arr, ellipseLength) {
    if (!Array.isArray(arr)) {
        return (<div>{arr}</div>);
    }

    const items = arr.slice(0, ellipseLength);

    return (
        <Fragment>
            {items.map((item, index) => (
                <div key={`${item}-${index}`}>{item}</div>
            ))}
            <ShowHide
                evaluator={arr.length > ellipseLength}
                show={(<div>&hellip;</div>)}
            />
        </Fragment>
    );
}

function arrToEllipsesLength(arr, ellipseLength, joinCharacter) {

    arr = arr.slice(0, ellipseLength);

    if (Array.isArray(arr)) {
        return arr.join(joinCharacter)
    }

    return arr;
}

function defaultJoin(arr, joinCharacter) {
    if (Array.isArray(arr)) {
        return arr.join(joinCharacter)
    }

    return arr;
}

ArrayToEllipsesString.propTypes = {
    length: PropTypes.number,
    joinCharacter: PropTypes.string,
    multiline: PropTypes.bool
};
